/**
 * * @module component/tooltip.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";

const Tooltip = Backbone.View.extend({
  el: $(document),

  events: {
    "click .access-item": "showTooltip",
    "mouseenter .access-item": "hoverTooltip",
  },

  initialize: function () {
    this.render();
  },

  hoverTooltip: function(e) {
    if(e.target.closest(".tooltip-parent-positioning")) {
      this.setPositionTooltip(e.target);
    }
  },

  showTooltip: function (e) {
    e.stopPropagation();
    const parentEl = $(e.target.closest('.access-item-wrapper'));

    if($(parentEl).hasClass("open")) {
      $(parentEl).removeClass("open");
      return;
    } 
    
    $(".access-item-wrapper").removeClass("open");
    $(parentEl).addClass("open");

    if(e.target.closest(".tooltip-parent-positioning")) {
      this.setPositionTooltip(e.target);
    }
  },

  setPositionTooltip(el){
    const parent = el.closest(".tooltip-parent-positioning");
    const tooltip = el.closest(".access-item-wrapper").querySelector(".tooltiptext");

    tooltip.className = tooltip.className.replace(new RegExp('(^|\\s)tooltiptext-position--\\S+', 'g'), '').trim();

    if(parent.getBoundingClientRect().left > tooltip.getBoundingClientRect().left) {
      tooltip.classList.add("tooltiptext-position--left")
    }

    else if (parent.getBoundingClientRect().right < tooltip.getBoundingClientRect().right) {
      tooltip.classList.add("tooltiptext-position--right")
    }

    if (parent.getBoundingClientRect().top > tooltip.getBoundingClientRect().top) {
      tooltip.classList.add("tooltiptext-position--top")
    }

  },

  render: function () {

    $(window).on("click", function(e){
      if($(".access-item-wrapper").hasClass("open") && !$(e.target).closest('.access-item-wrapper').length) {
        $(".access-item-wrapper").removeClass("open")
      }
    });

  },
});

export default Tooltip;
